import { walkFilter } from '@/lib/filter/filter';

const hasApplication = (child, model) => {
  if (child.scope.property === undefined && child.scope.directProperty === undefined) {
    return false;
  }
  if (child.scope.property !== undefined && child.scope.property.model === model) {
    return true;
  }
  if (child.scope.directProperty !== undefined && child.scope.directProperty.model === model) {
    return true;
  }
  return false;
};

export const extractFilter = (filter, model) => {
  if (filter === undefined || filter === null || !Array.isArray(filter.children)) {
    return null;
  }

  const filterFunc = (child) => hasApplication(child, model);
  const children = filter.children.reduce(walkFilter(filterFunc), []);
  if (children.length === 0) {
    return null;
  }

  return {
    ...filter,
    children,
  };
};
